module.exports = __webpack_public_path__ + "img/banner.2fb20d43.jpg";